/*
 * @Author: tanyaohua
 * @Date: 2019-12-31 13:26:12
 * @Description: 列表图的组件
 */

angular.module('AppListInfoModule', []).directive('appListInfo', [
    'trsHttpService',
    'globleParamsSet',
    'editingCenterAppService',
    '$stateParams',
    'modalDialog',
    '$state',
    function(trsHttpService, globleParamsSet, editingCenterAppService, $stateParams, modalDialog, $state) {
        return {
            scope: true, // 继承作用域
            restrict: 'EA',
            templateUrl: './editingCenter/directive/editPagePart/app/appListInfo/listInfo.html',
            replace: true,
            transclude: true,
            link: function($scope) {
                initStatus();
                initData();

                /**
                 * [initStatus description]初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.data = {
                        // 列表样式
                        listStyle: editingCenterAppService.initListStyle(),
                    };
                }

                /**
                 * [initData description]初始化数据
                 *
                 * @return  {[type]}  [return description]
                 */
                function initData() {}

                /**
                 * [deleteUploaderImg description]删除上传后的图片
                 * @param  {[str]} attribute [description]要删除的属性
                 * @param  {[num]} index     [description]下标
                 * @return {[type]}           [description]
                 */
                $scope.deleteUploaderImg = function(attribute, index) {
                    if (attribute === 'LISTPICS') {
                        $scope.list[attribute][index] = {
                            APPFILE: '',
                            APPDESC: '',
                            PERPICURL: '',
                        };
                    } else {
                        $scope.list[attribute] = [];
                    }
                };

                /**
                 * [updateCKSelection description] 焦点图切换
                 * @return  {[type]}  [return description]
                 */
                $scope.updateCKSelection = function () {
                    // if ($state.params.appplatform === '2') {
                    //     modalDialog.alertType('', '稿件已签发后，无法勾选或取消勾选栏目焦点图', 'error', false, function() {});
                    //     return;
                    // }
                    $scope.list.ISFOCUSIMAGE = $scope.list.ISFOCUSIMAGE === '1' ? '0' : '1';
                };
            },
        };
    },
]);
